import { createStore } from 'vuex';
import { parseUrlFilters } from 'utils/url';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import * as user from '../modules/user';
import * as generic from '../modules/generic';
import * as productComparison from '../modules/product-comparison';
import { cloneObject } from '../../utils';

const getDocumentWidth = () => document.documentElement.getBoundingClientRect().width;

const state = {
  results: {
    total: 0,
    hits: [],
    aggregations: {}
  },
  urlFilters: parseUrlFilters(),
  filterConfig: payload.filterConfig ? cloneObject(payload.filterConfig) : null,
  activeDropDownFilter: null,
  isLoading: false,
  fieldManifest: payload.fieldManifest ? cloneObject(payload.fieldManifest) : null,
  mobileFilterBarVisible: false,
  basket: [],
  availableTabs: ['overview', 'favorites'],
  documentWidth: getDocumentWidth(),
  ingredient: payload.ingredient ? cloneObject(payload.ingredient) : null,
};

window.addEventListener('resize', () => {
  state.documentWidth = getDocumentWidth();
}, false);

const store = createStore({
  modules: {
    user,
    generic,
    productComparison
  },
  state,
  getters,
  actions,
  mutations
});

user.init(store);
generic.init(store);

// Disable the product comparison basket
store.dispatch('productComparison/disableBasket');

export default store;
